/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled, { css } from 'styled-components';
import Icons from './index';

const StyledSvg = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink'
})``;

const StyledIcon = styled(StyledSvg)`
  margin: ${({ margin }) => margin || '0 8px'};
  float: ${({ float }) => float || 'left'};
  ${({ size }) =>
    size === 100 &&
    css`
      width: 16px;
      height: 16px;
    `}
    ${({ size }) =>
      size === 150 &&
      css`
        width: 18px;
        height: 18px;
      `}
  ${({ size }) =>
    size === 200 &&
    css`
      width: 24px;
      height: 24px;
    `}
  ${({ size }) =>
    size === 300 &&
    css`
      width: 32px;
      height: 32px;
    `}
    path {
      ${({ svgPathFill }) =>
        svgPathFill &&
        css`
          fill: ${p => p.svgPathFill};
        `}
    }
`;

export const Icon = ({ name, size = 100, margin, float, svgPathFill, dataPanel }) => {
  const Ico = Icons[name];
  if (Ico === undefined) {
    return '';
  }

  return (
    <StyledIcon
      size={size}
      margin={margin}
      float={float}
      svgPathFill={svgPathFill}
      data-panel={`selector-icon-${dataPanel}`}
    >
      <Ico />
    </StyledIcon>
  );
};
